export const toYYYYMMDD = (date: Date | string, delimiter = '/'): string | null => {
  if (date == null) return null;
  const dateObj = new Date(date);
  return `${dateObj.getFullYear()}${delimiter}${`00${dateObj.getMonth() + 1}`.slice(-2)}${delimiter}${`00${dateObj.getDate()}`.slice(-2)}`;
};
